module.exports = __webpack_public_path__ + "img/service_support_header.22da5c8c.png";